export class Entity {
  Username: string = '';
  SearchdropFirst: string = '';
  SearchdropSecond: string = '';
  SearchMatchesFirst: string = '';
  SearchMatchesSecond: string = '';
  SearchtextFirst: any = '';
  SearchtextSecond: any = '';
  tenantDisplayName: string = "";
  TenantId: number;
  DisplayHotelId: number;
  EntityCode: string;
  Phone: string = '';
  Type: string = '';
  EntityID: string = '';
  EntityStatus: string = '';
  Entityname: string = '';
  ZipCode: string = '';
  CCZipCode: string = '';
  InnCode: string = '';
  OrganizationCode: string = '';
  OrganizationName: string = '';
  Legalname: string = '';
  OwnerName: string = '';
  OwnerEmail: string = '';
  OwnerPhone: number;
  HotelBrandOther: string = '';
  NonUS: boolean;
  DayLightSavings: boolean;
  DoubleEntrySystem: string = '';
  BillByCC: boolean;
  TaxID: number;
  FranchiseDD: string = '';
  HotelBrandDD: string = '';
  Brand: string = '';
  BillingFrequency: string = '';
  DigitalACS: string = '';
  Address1: string = '';
  Country: string = '';
  city: string = '';
  state: string = '';
  Status: string = '';
  TimeZone: string = '';
  Province: string = '';
  AccountExecutive: any = '';
  IFGuru: string = '';
  IFGuruEmail: string = '';
  IFGuruPhone: number;
  TerminationDate: any = '';
  StartingDate: any = '';
  SalesTax: string = '';
  CCtype: string = '';
  CCNumber: string = '';
  AStreet: string = '';
  CCName: string = '';
  OverTime: string = '';
  DoubleOverTime: string = '';
  HolidayRate: string = '';
  BankRoutingNumber: string = '';
  Bankname: string = '';
  PMSname: string = '';
  BankAccNumber: string = '';
  ExpirationDate: any = '';
  ReasonForTermination: string = '';
  TerminationNotes: string = '';
  PMS_System: any ='';
  Accounting: any = "";
  Labour_Management: any = "";
  Payroll: any = "";
  Procurement: any = "";
  Sales: any = "";
  Facilities_Management: any = "";
  PMS_SystemId: string = "";
  AccountingId: string = "";
  Labour_ManagementId: string = "";
  PayrollId: string = "";
  Intersectid: string = "";
  ProcurementId: string = "";
  SalesId: string = "";
  Facilities_ManagementId: string = "";
  AddApp: any = '';
  AppEntryType: any = '';
  AddBrand: any = '';
  AddAppId: string = '';
  value: string = '';
  AddBrandId: string = '';
  Queryname: string = '';
  BankCode: string = '';
  BankStreetAddress: string = '';
  AddressOnStreet: string = '';
  FranchiseBrand: any = "";
  HotelBrand: any = '';
  FranchiseBrandID: String = '';
  HotelBrandID: String = '';
  FranchiseGroupID: String = '';
  HotelGroupID: String = '';
  SalesTaxId: string='';
  EditAddBrand: any = '';
  DailyActivityId: string = '';
  DoubleEntrySystemEntry: string = '';
  EPaySetting: boolean;
  DualPMSSetting: boolean;
  pmsMaster: string = '';
  FeatureFlagEpay: boolean;
  ePay: string;
  isDualPMS: string;


  SearchdropFirstList: any[] = [
    { Value: 'EntityID', Text: 'EntityID' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'OrgName', Text: 'Org Name' },
    //{ Value: 'Org, Text', Text: 'Org , Text' },
    { Value: 'EntityCity', Text: 'City' },
    { Value: 'EntityState', Text: 'State' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'Franchise', Text: 'Franchise' },
    { Value: 'Brand', Text: 'Brand' }
  ]
  SearchdropSecondList: any[] = [
    { Value: 'EntityID', Text: 'EntityID' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'OrgName', Text: 'Org Name' },
    //{ Value: 'Org, Text', Text: 'Org , Text' },
    { Value: 'EntityCity', Text: 'City' },
    { Value: 'EntityState', Text: 'State' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'Franchise', Text: 'Franchise' },
    { Value: 'Brand', Text: 'Brand' }
  ]
  TimeZoneList: any[] = [
    { value: '1', gmtAdjustment: 'GMT-12:00', useDaylightTime: '0', Defaultvalue: '-12', Text: '(GMT-12:00) International Date Line West' },
    { value: '2', gmtAdjustment: 'GMT-11:00', useDaylightTime: '0', Defaultvalue: '-11', Text: '(GMT-11:00) Midway Island, Samoa' },
    { value: '3', gmtAdjustment: 'GMT-10:00', useDaylightTime: '0', Defaultvalue: '-10', Text: '(GMT-10:00) Hawaii' },
    { value: '4', gmtAdjustment: 'GMT-09:00', useDaylightTime: '1', Defaultvalue: '-9', Text: '(GMT-09:00) Alaska' },
    { value: '5', gmtAdjustment: 'GMT-08:00', useDaylightTime: '1', Defaultvalue: '-8', Text: '(GMT-08:00) Pacific Time (US & Canada)' },
    { value: '6', gmtAdjustment: 'GMT-08:00', useDaylightTime: '1', Defaultvalue: '-8', Text: '(GMT-08:00) Tijuana, Baja California' },
    { value: '7', gmtAdjustment: 'GMT-07:00', useDaylightTime: '0', Defaultvalue: '-7', Text: '(GMT-07:00) Arizona' },
    { value: '8', gmtAdjustment: 'GMT-07:00', useDaylightTime: '1', Defaultvalue: '-7', Text: '(GMT-07:00) Chihuahua, La Paz, Mazatlan' },
    { value: '9', gmtAdjustment: 'GMT-07:00', useDaylightTime: '1', Defaultvalue: '-7', Text: '(GMT-07:00) Mountain Time (US & Canada)' },
    { value: '10', gmtAdjustment: 'GMT-06:00', useDaylightTime: '0', Defaultvalue: '-6', Text: '(GMT-06:00) Central America' },
    { value: '11', gmtAdjustment: 'GMT-06:00', useDaylightTime: '1', Defaultvalue: '-6', Text: '(GMT-06:00) Central Time (US & Canada)' },
    { value: '12', gmtAdjustment: 'GMT-06:00', useDaylightTime: '1', Defaultvalue: '-6', Text: '(GMT-06:00) Guadalajara, Mexico City, Monterrey' },
    { value: '13', gmtAdjustment: 'GMT-06:00', useDaylightTime: '0', Defaultvalue: '-6', Text: '(GMT-06:00) Saskatchewan' },
    { value: '14', gmtAdjustment: 'GMT-05:00', useDaylightTime: '0', Defaultvalue: '-5', Text: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco' },
    { value: '15', gmtAdjustment: 'GMT-05:00', useDaylightTime: '1', Defaultvalue: '-5', Text: '(GMT-05:00) Eastern Time (US & Canada)' },
    { value: '16', gmtAdjustment: 'GMT-05:00', useDaylightTime: '1', Defaultvalue: '-5', Text: '(GMT-05:00) Indiana (East)' },
    { value: '17', gmtAdjustment: 'GMT-04:00', useDaylightTime: '1', Defaultvalue: '-4', Text: '(GMT-04:00) Atlantic Time (Canada)' },
    { value: '18', gmtAdjustment: 'GMT-04:00', useDaylightTime: '0', Defaultvalue: '-4', Text: '(GMT-04:00) Caracas, La Paz' },
    { value: '19', gmtAdjustment: 'GMT-04:00', useDaylightTime: '0', Defaultvalue: '-4', Text: '(GMT-04:00) Manaus' },
    { value: '20', gmtAdjustment: 'GMT-04:00', useDaylightTime: '1', Defaultvalue: '-4', Text: '(GMT-04:00) Santiago' },
    { value: '21', gmtAdjustment: 'GMT-03:30', useDaylightTime: '1', Defaultvalue: '-3.5', Text: '(GMT-03:30) Newfoundland' },
    { value: '22', gmtAdjustment: 'GMT-03:00', useDaylightTime: '1', Defaultvalue: '-3', Text: '(GMT-03:00) Brasilia' },
    { value: '23', gmtAdjustment: 'GMT-03:00', useDaylightTime: '0', Defaultvalue: '-3', Text: '(GMT-03:00) Buenos Aires, Georgetown' },
    { value: '24', gmtAdjustment: 'GMT-03:00', useDaylightTime: '1', Defaultvalue: '-3', Text: '(GMT-03:00) Greenland' },
    { value: '25', gmtAdjustment: 'GMT-03:00', useDaylightTime: '1', Defaultvalue: '-3', Text: '(GMT-03:00) Montevideo' },
    { value: '26', gmtAdjustment: 'GMT-02:00', useDaylightTime: '1', Defaultvalue: '-2', Text: '(GMT-02:00) Mid-Atlantic' },
    { value: '27', gmtAdjustment: 'GMT-01:00', useDaylightTime: '0', Defaultvalue: '-1', Text: '(GMT-01:00) Cape Verde Is.' },
    { value: '28', gmtAdjustment: 'GMT-01:00', useDaylightTime: '1', Defaultvalue: '-1', Text: '(GMT-01:00) Azores' },
    { value: '29', gmtAdjustment: 'GMT+00:00', useDaylightTime: '0', Defaultvalue: '0', Text: '(GMT+00:00) Casablanca, Monrovia, Reykjavik' },
    { value: '30', gmtAdjustment: 'GMT+00:00', useDaylightTime: '1', Defaultvalue: '0', Text: '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London' },
    { value: '31', gmtAdjustment: 'GMT+01:00', useDaylightTime: '1', Defaultvalue: '1', Text: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
    { value: '32', gmtAdjustment: 'GMT+01:00', useDaylightTime: '1', Defaultvalue: '1', Text: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague' },
    { value: '33', gmtAdjustment: 'GMT+01:00', useDaylightTime: '1', Defaultvalue: '1', Text: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris' },
    { value: '34', gmtAdjustment: 'GMT+01:00', useDaylightTime: '1', Defaultvalue: '1', Text: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb' },
    { value: '35', gmtAdjustment: 'GMT+01:00', useDaylightTime: '1', Defaultvalue: '1', Text: '(GMT+01:00) West Central Africa' },
    { value: '36', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Amman' },
    { value: '37', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Athens, Bucharest, Istanbul' },
    { value: '38', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Beirut' },
    { value: '39', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Cairo' },
    { value: '40', gmtAdjustment: 'GMT+02:00', useDaylightTime: '0', Defaultvalue: '2', Text: '(GMT+02:00) Harare, Pretoria' },
    { value: '41', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
    { value: '42', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Jerusalem' },
    { value: '43', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Minsk' },
    { value: '44', gmtAdjustment: 'GMT+02:00', useDaylightTime: '1', Defaultvalue: '2', Text: '(GMT+02:00) Windhoek' },
    { value: '45', gmtAdjustment: 'GMT+03:00', useDaylightTime: '0', Defaultvalue: '3', Text: '(GMT+03:00) Kuwait, Riyadh, Baghdad' },
    { value: '46', gmtAdjustment: 'GMT+03:00', useDaylightTime: '1', Defaultvalue: '3', Text: '(GMT+03:00) Moscow, St. Petersburg, Volgograd' },
    { value: '47', gmtAdjustment: 'GMT+03:00', useDaylightTime: '0', Defaultvalue: '3', Text: '(GMT+03:00) Nairobi' },
    { value: '48', gmtAdjustment: 'GMT+03:00', useDaylightTime: '0', Defaultvalue: '3', Text: '(GMT+03:00) Tbilisi' },
    { value: '49', gmtAdjustment: 'GMT+03:30', useDaylightTime: '1', Defaultvalue: '3.5', Text: '(GMT+03:30) Tehran' },
    { value: '50', gmtAdjustment: 'GMT+04:00', useDaylightTime: '0', Defaultvalue: '4', Text: '(GMT+04:00) Abu Dhabi, Muscat' },
    { value: '51', gmtAdjustment: 'GMT+04:00', useDaylightTime: '1', Defaultvalue: '4', Text: '(GMT+04:00) Baku' },
    { value: '52', gmtAdjustment: 'GMT+04:00', useDaylightTime: '1', Defaultvalue: '4', Text: '(GMT+04:00) Yerevan' },
    { value: '53', gmtAdjustment: 'GMT+04:30', useDaylightTime: '0', Defaultvalue: '4.5', Text: '(GMT+04:30) Kabul' },
    { value: '54', gmtAdjustment: 'GMT+05:00', useDaylightTime: '1', Defaultvalue: '5', Text: '(GMT+05:00) Yekaterinburg' },
    { value: '55', gmtAdjustment: 'GMT+05:00', useDaylightTime: '0', Defaultvalue: '5', Text: '(GMT+05:00) Islamabad, Karachi, Tashkent' },
    { value: '56', gmtAdjustment: 'GMT+05:30', useDaylightTime: '0', Defaultvalue: '5.5', Text: '(GMT+05:30) Sri Jayawardenapura' },
    { value: '57', gmtAdjustment: 'GMT+05:30', useDaylightTime: '0', Defaultvalue: '5.5', Text: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
    { value: '58', gmtAdjustment: 'GMT+05:45', useDaylightTime: '0', Defaultvalue: '5.75', Text: '(GMT+05:45) Kathmandu' },
    { value: '59', gmtAdjustment: 'GMT+06:00', useDaylightTime: '1', Defaultvalue: '6', Text: '(GMT+06:00) Almaty, Novosibirsk' },
    { value: '60', gmtAdjustment: 'GMT+06:00', useDaylightTime: '0', Defaultvalue: '6', Text: '(GMT+06:00) Astana, Dhaka' },
    { value: '61', gmtAdjustment: 'GMT+06:30', useDaylightTime: '0', Defaultvalue: '6.5', Text: '(GMT+06:30) Yangon (Rangoon)' },
    { value: '62', gmtAdjustment: 'GMT+07:00', useDaylightTime: '0', Defaultvalue: '7', Text: '(GMT+07:00) Bangkok, Hanoi, Jakarta' },
    { value: '63', gmtAdjustment: 'GMT+07:00', useDaylightTime: '1', Defaultvalue: '7', Text: '(GMT+07:00) Krasnoyarsk' },
    { value: '64', gmtAdjustment: 'GMT+08:00', useDaylightTime: '0', Defaultvalue: '8', Text: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi' },
    { value: '65', gmtAdjustment: 'GMT+08:00', useDaylightTime: '0', Defaultvalue: '8', Text: '(GMT+08:00) Kuala Lumpur, Singapore' },
    { value: '66', gmtAdjustment: 'GMT+08:00', useDaylightTime: '0', Defaultvalue: '8', Text: '(GMT+08:00) Irkutsk, Ulaan Bataar' },
    { value: '67', gmtAdjustment: 'GMT+08:00', useDaylightTime: '0', Defaultvalue: '8', Text: '(GMT+08:00) Perth' },
    { value: '68', gmtAdjustment: 'GMT+08:00', useDaylightTime: '0', Defaultvalue: '8', Text: '(GMT+08:00) Taipei' },
    { value: '69', gmtAdjustment: 'GMT+09:00', useDaylightTime: '0', Defaultvalue: '9', Text: '(GMT+09:00) Osaka, Sapporo, Tokyo' },
    { value: '70', gmtAdjustment: 'GMT+09:00', useDaylightTime: '0', Defaultvalue: '9', Text: '(GMT+09:00) Seoul' },
    { value: '71', gmtAdjustment: 'GMT+09:00', useDaylightTime: '1', Defaultvalue: '9', Text: '(GMT+09:00) Yakutsk' },
    { value: '72', gmtAdjustment: 'GMT+09:30', useDaylightTime: '0', Defaultvalue: '9.5', Text: '(GMT+09:30) Adelaide' },
    { value: '73', gmtAdjustment: 'GMT+09:30', useDaylightTime: '0', Defaultvalue: '9.5', Text: '(GMT+09:30) Darwin' },
    { value: '74', gmtAdjustment: 'GMT+10:00', useDaylightTime: '0', Defaultvalue: '10', Text: '(GMT+10:00) Brisbane' },
    { value: '75', gmtAdjustment: 'GMT+10:00', useDaylightTime: '1', Defaultvalue: '10', Text: '(GMT+10:00) Canberra, Melbourne, Sydney' },
    { value: '76', gmtAdjustment: 'GMT+10:00', useDaylightTime: '1', Defaultvalue: '10', Text: '(GMT+10:00) Hobart' },
    { value: '77', gmtAdjustment: 'GMT+10:00', useDaylightTime: '0', Defaultvalue: '10', Text: '(GMT+10:00) Guam, Port Moresby' },
    { value: '78', gmtAdjustment: 'GMT+10:00', useDaylightTime: '1', Defaultvalue: '10', Text: '(GMT+10:00) Vladivostok' },
    { value: '79', gmtAdjustment: 'GMT+11:00', useDaylightTime: '1', Defaultvalue: '11', Text: '(GMT+11:00) Magadan, Solomon Is., New Caledonia' },
    { value: '80', gmtAdjustment: 'GMT+12:00', useDaylightTime: '1', Defaultvalue: '12', Text: '(GMT+12:00) Auckland, Wellington' },
    { value: '81', gmtAdjustment: 'GMT+12:00', useDaylightTime: '0', Defaultvalue: '12', Text: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.' },
    { value: '82', gmtAdjustment: 'GMT+13:00', useDaylightTime: '0', Defaultvalue: '13', Text: '(GMT+13:00) Nukualofa' }
  ]
    

}



// WEBPACK FOOTER //
// ./src/app/Classes/EntityClass.ts